import { queryClient } from "@src/queryClient";
import { ReactQueryDevtoolsPanel } from "@tanstack/react-query-devtools";
import { Box } from "@mui/material";

import { DESIGN_TOKENS, REACT_GRAB_IGNORE_ATTR } from "../constants";

type ReactQueryPanelProps = {
  onClose: () => void;
};

export const ReactQueryPanel = ({ onClose }: ReactQueryPanelProps) => (
  <Box {...{ [REACT_GRAB_IGNORE_ATTR]: "" }} sx={DESIGN_TOKENS.panel}>
    <ReactQueryDevtoolsPanel
      client={queryClient}
      style={{ height: "100%" }}
      onClose={onClose}
    />
  </Box>
);
